import React, { Component } from 'react'
import './index.css'

function getElementVisibility(el, stopParent) {
  if (!el || !(el instanceof Element)) {
    throw new TypeError("Expected a DOM Element");
  }

  const style = window.getComputedStyle(el);

  if (
    style.display === "none" ||
    style.visibility === "hidden" ||
    style.visibility === "collapse" ||
    Number(style.opacity) === 0
  ) {
    return "hidden";
  }

  let visibleRect = el.getBoundingClientRect();

  if (visibleRect.width <= 0 || visibleRect.height <= 0) {
    return "hidden";
  }

  const originalRect = visibleRect;

  // Intersect with viewport
  visibleRect = intersectRects(visibleRect, {
    top: 0,
    left: 0,
    right: window.innerWidth || document.documentElement.clientWidth,
    bottom: window.innerHeight || document.documentElement.clientHeight
  });

  if (!visibleRect) {
    return "hidden";
  }

  // Intersect with clipping ancestors
  let parent = el.parentElement;

  while (parent) {
    const parentStyle = window.getComputedStyle(parent);

    const clips =
      /(hidden|auto|scroll|clip)/.test(parentStyle.overflow) ||
      /(hidden|auto|scroll|clip)/.test(parentStyle.overflowX) ||
      /(hidden|auto|scroll|clip)/.test(parentStyle.overflowY);

    if (clips) {
      const parentRect = parent.getBoundingClientRect();

      visibleRect = intersectRects(visibleRect, parentRect);

      if (!visibleRect) {
        return "hidden";
      }
    }
    parent = parent.parentElement;
    if (parent === stopParent) {
      break
    }
  }

  const fullyVisible =
    rectsAlmostEqual(visibleRect, originalRect);

  return fullyVisible ? "visible" : "partially-hidden";
}

function intersectRects(a, b) {
  const top = Math.max(a.top, b.top);
  const left = Math.max(a.left, b.left);
  const right = Math.min(a.right, b.right);
  const bottom = Math.min(a.bottom, b.bottom);

  if (right <= left || bottom <= top) {
    return null;
  }

  return {
    top,
    left,
    right,
    bottom,
    width: right - left,
    height: bottom - top
  };
}

function rectsAlmostEqual(a, b, epsilon = 0.5) {
  return (
    Math.abs(a.top - b.top) <= epsilon &&
    Math.abs(a.left - b.left) <= epsilon &&
    Math.abs(a.right - b.right) <= epsilon &&
    Math.abs(a.bottom - b.bottom) <= epsilon
  );
}

export class Dots extends React.Component {

  setRef = ref => {
    this.ref = ref
  }

  componentDidUpdate(prevProps) {
    ////console.log('props', prevProps, "=>", this.props)
    if (this.dot && this.dot.ref) {
      if (this.props.position !== prevProps.position) {
        if (getElementVisibility(this.dot.ref) === 'hidden', this.ref) {
          let inline = 'end'
          if (this.props.position < prevProps.position) {
            inline = 'start'
          }
          clearTimeout(this.dotViz)
          if (this.dot.ref) {
            clearTimeout(this.dotViz)
            this.dotViz = setTimeout(() => {
              if (this.dot.ref) {
                this.dot.ref.scrollIntoView({
                  behavior: "smooth",
                  block: "nearest",   // vertical: move as little as possible
                  inline: 'nearest'
                })
              }
            }, 400)
          }
        }
      }
    }
  }

  updatePosition = (position) => {
    if (this.props.clickable) {
      if (this.props.positionChangeListener) {
        this.props.positionChangeListener(position)
      }
    }
  }
  
  generateDotHolders() {
    let dotHolders = []
    for (var i = 0; i < this.props.length; i++) {
      dotHolders.push(<DotHolder key={i} position={i} margin={this.props.margin} length={this.props.length} clickable={this.props.clickable} size={this.props.size} updatePosition={this.updatePosition} />)
    }
    return dotHolders
  }
  
  render() {
    if (!this.props.length || this.props.length < 2) return null
    const dotHolders = this.generateDotHolders()
    //console.log("position => ", this.props.position)
    const sliderStyle = 'slider'
    const style = {
      width: this.props.length * (this.props.size + this.props.margin) - this.props.margin
    }
    return (
      <div ref={this.setRef} style={style} className={sliderStyle}>
        <div style={style} className="dot-holders">
          { dotHolders }
        </div>
        <Dot position={this.props.position} size={this.props.size} margin={this.props.margin} onCreate={dot=>{
               this.dot = dot
             }}/>
      </div>
    )
  }
}

class DotHolder extends React.Component {

    render() {
      const dotHolderStyle = this.props.clickable ? 'dot-holder dot-holder-clickable' : 'dot-holder'
      const { position, size, margin } = this.props
      const style = {
        left: position * (size + margin),
        width: size,
        height: size
      }
        return (
            <div style={style} className={dotHolderStyle} onClick={(e) => this.props.updatePosition(this.props.position, e)}></div>
        )
    }
}

class Dot extends React.Component {

  componentDidUpdate(prevProps) {
    if (this.props.position !== prevProps.position) {
      
    }
  }

  componentDidMount() {
    if (this.props.onCreate) {
      this.props.onCreate(this)
    }
  }
  
  setRef = ref => {
    this.ref = ref
  }
  render() {
      const positionClass = 'dot'
      const offset = 1 * this.props.size / 10;
      const style = {
        left: offset + this.props.position * (this.props.size + this.props.margin),
        top: offset,
        width: this.props.size-(offset * 2),
        height: this.props.size-(offset * 2)
      }
  
      return(
        <div ref={this.setRef} style={style} className={ positionClass }></div>
      )
    }
}

Dots.defaultProps = {
  position: 0,
  length: 3,
  size: 10,
  margin: 3,
  clickable: true,
  positionChangeListener: null
}


